import React, { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router'
import KitSelectStyle from './KitSelect.module.css'
import renderImage from '../../source/importImg'
import getBackendImage from '../../source/imageUtil'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import DialogModal from '../ReusableComponents/DialogModal/DialogModal'
import { fetchVersion } from './FlashFiles'
import { MenuItem, Select } from '@material-ui/core'
import { setLanguageSelect, setSelectionBackRoute } from '../../redux/actions'
import { connect } from 'react-redux'
import { languageMenu, languageWords } from '../../utils/langaugeSupport'
import { codableKits } from '../../utils/kitTabs'
import {
    isDeviceEnabled,
    getDeviceDisplayName,
    getCardHeroImage,
    getExpansionKits,
    getExpansionKitHeroImage,
    getCategories,
    getCategoryItems,
} from '../../hooks/useBrandConfig'
import { getVersionArguments } from '../../utils/verionControl'
import contentApi, { USE_NEW_API } from '../../utils/contentApi'
import { EXPANSION_KIT_TAB_GROUPS, EXPANSION_KITS } from '../../utils/expansionKits'
import {
    CATEGORY_SOURCES,
    getCategorySource,
    isCategoryFromSource,
} from '../../utils/categorySources'

const BACKEND_URL = process.env.REACT_APP_API_BASE

// Hardcoded image keys per program id (uses renderImage)
const PROGRAM_IMAGE_MAP = {
    toki: 'talkingDragon',
    poki: 'PokiRoverKit',
    makeyExpansionKit: 'makeyExpansionKit',

    ioExpansionKit1: 'PokiRoverKit',
    ioExpansionKit2: 'ioExpansionKit2',

    roverExpansionKit1: 'PokiRoverKit',
    roverExpansionKit2: 'ioExpansionKit2',
    woofExpansionKit3: 'woofExpansionKit3',
    roarmExpansionKit4: 'roarmExpansionKit4',
    walkerExpansionKit5: 'walkerExpansionKit5',

    omniBotRoverExpansionKit: 'omniBotRoverExpansionKit',
    omniBotShooterExpansionKit: 'omniBotShooterExpansionKit',
    spidyExpansionKit: 'spidyExpansionKit',
    integratedRoboticsExpansionKit: 'integratedRoboticsExpansionKit',
}

// Routes per program id for user-facing engine
const PROGRAM_ENGINE_ROUTE = {
    toki: '/kitMenu',
    poki: '/kitMenu',
}

// Message shown on expansion kits that have no projects yet.
// Kept here so the copy can be changed in one place.
const COMING_SOON_TEXT = 'Coming soon!'
// Banner shown on discontinued kits (greyed image + this label). Kept here
// so the copy can be changed in one place, same as COMING_SOON_TEXT.
const DISCONTINUED_TEXT = 'Discontinued!'

// Expansion kits whose card image is pinned to a specific local asset
// (set directly, not through the backend/brand-config image). These always
// show the local image instead of whatever the backend returns for them.
const FORCE_LOCAL_EXPANSION_KIT_IMAGE = new Set([
    'makeyExpansionKit',
    'ioExpansionKit1',
    'ioExpansionKit2',
    'roverExpansionKit1',
    'roverExpansionKit2',
    'woofExpansionKit3',
    'ioExpansionKit3',
    'homeAutomationKit',
    'industrialExpansionKit',
    'roarmExpansionKit4',
    'walkerExpansionKit5',
])

// The Codable Kits and Expansion Kits tabs are backend-backed: their cards come
// from the API, not from the static catalog content. Matched by the category
// `source` key, falling back to slug/title so existing brand configs keep working.
const isExpansionTab = (tab) =>
    isCategoryFromSource(tab, CATEGORY_SOURCES.EXPANSION_KITS)
const isCodableTab = (tab) =>
    isCategoryFromSource(tab, CATEGORY_SOURCES.CODABLE_KITS)
const isComingSoonCategoryTab = (tab) => tab.comingSoon === true

// const tabs = [
//     {
//         id: 1,
//         title: 'CodableKits',
//         defaultDevice: 'Ace',
//         content: [
//             {
//                 device: 'Moki',
//                 name: 'Moki',
//                 src: 'moki',
//                 nav: '',
//             },
//             {
//                 device: 'Toki',
//                 name: 'Toki',
//                 src: 'toki',
//                 nav: '',
//             },
//             {
//                 device: 'Poki',
//                 name: 'Poki',
//                 src: 'tokiPlus',
//                 nav: '',
//             },
//             {
//                 device: 'Roboki',
//                 name: 'Roboki',
//                 src: 'roboki',
//                 nav: '',
//             },
//             {
//                 device: 'Ace1',
//                 name: 'PeeCee',
//                 src: 'peeCeeB',
//                 nav: '',
//             },

//             {
//                 device: 'Ace0',
//                 name: 'PeeCee v0.1',
//                 src: 'peeCeeA',
//                 nav: '',
//             },
//         ],
//     },
//     {
//         id: 2,
//         title: 'Animatronics',
//         defaultDevice: 'Humanoid',
//         content: [
//             {
//                 device: 'Klaw',
//                 name: 'Klaw-b',
//                 src: 'klaw',
//                 nav: '',
//             },
//             {
//                 device: 'Hexapod',
//                 name: 'Crawl-e',
//                 src: 'crawle',
//                 nav: '',
//             },
//             {
//                 device: 'Humanoid',
//                 name: 'Zing',
//                 src: 'zing',
//                 nav: '',
//             },
//         ],
//     },
//     {
//         id: 3,
//         title: 'RoboticKits',
//         defaultDevice: 'Atr',
//         content: [
//             {
//                 device: 'Atr',
//                 name: 'Atr',
//                 src: 'ATRkit',
//                 nav: '',
//             },
//         ],
//     },
//     {
//         id: 4,
//         title: 'Electronics',
//         defaultDevice: 'Trons',
//         content: [
//             {
//                 name: 'Playtrons',
//                 src: 'trons',
//                 nav: 'https://playtrons.plode.org/projects',
//             },
//             {
//                 name: 'Playtronix',
//                 src: 'tronix',
//                 nav: 'https://playtronix.plode.org/',
//             },

//             // {
//             //     name: 'Plode X',
//             //     src: 'plodeX',
//             //     nav: 'https://plodex.plode.org/workspace',
//             // },
//         ],
//     },
//     {
//         id: 5,
//         title: 'Mechanical',
//         defaultDevice: 'Trons',
//         content: [
//             {
//                 name: 'Playdynamex',
//                 src: 'kitSelectionDynamex',
//                 nav: 'https://plode.org/play/#/playdynamex',
//             },
//             // {
//             //     name: 'Plode X',
//             //     src: 'plodeX',
//             //     nav: 'https://plodex.plode.org/workspace',
//             // },
//         ],
//     },
// ]

function getCompletedSubprograms() {
    try {
        const saved = sessionStorage.getItem('completedSubprograms')
        return saved ? JSON.parse(saved) : []
    } catch {
        return []
    }
}

const KitSelection = (props) => {
    const [isHelp, setHelp] = useState(false)
    const [search, setSearch] = useState('')
    // const [activeTab, setActiveTab] = useState(tabs[0].id)
    const [filteredResults, setFilteredResults] = useState({})
    const [suggestions, setSuggestions] = useState([])
    // expansionKitId of the search suggestion whose device flyout is open
    // (only set for a kit supported by more than one device)
    const [openDeviceFlyout, setOpenDeviceFlyout] = useState(null)
    // top offset (px, relative to searchInputRef) so the flyout lines up
    // with the row that was clicked instead of always sitting at the top
    const [flyoutTop, setFlyoutTop] = useState(0)
    const searchInputRef = useRef(null)
    const [showLanguagePopup, setShowLanguagePopup] = useState(false)
    const [languageValue, setLanguageValue] = useState(props.device.language)
    const [codableKitItems, setCodableKitItems] = useState([])
    // Tracks whether the /api/programs response has arrived so we can tell
    // "still loading" apart from "loaded but empty" (empty → "Coming Soon").
    const [programsLoaded, setProgramsLoaded] = useState(false)
    const [expansionKitItems, setExpansionKitItems] = useState([])
    const [expansionKitsStatus, setExpansionKitsStatus] = useState('loading')
    // Subprograms across all programs — used only for search suggestions
    const [subprogramItems, setSubprogramItems] = useState([])
    // Expansion Kits tab: clicking it swaps the left sidebar's category list
    // for a device list (Toki/Poki/Moki); selecting a device then filters the
    // right panel down to that device's kits. Back button restores both.
    const [expansionKitDeviceMode, setExpansionKitDeviceMode] = useState(
        () => Boolean(sessionStorage.getItem('expansionKitRestoreDevice'))
    )
    const [selectedExpansionDevice, setSelectedExpansionDevice] = useState(
        () => sessionStorage.getItem('expansionKitRestoreDevice') || null
    )
    // Inline tutorial view: set when a kit card is clicked in device mode.
    const [selectedExpansionKit, setSelectedExpansionKit] = useState(null)
    const [expansionKitTutorials, setExpansionKitTutorials] = useState([])
    const [tutorialsLoading, setTutorialsLoading] = useState(false)
    // Scrolls the kit grid back to top when switching devices, so picking
    // Moki after scrolling down Poki's list doesn't leave the view scrolled.
    const expansionTabContentRef = useRef(null)
    useEffect(() => {
        if (expansionTabContentRef.current) {
            expansionTabContentRef.current.scrollTop = 0
        }
    }, [selectedExpansionDevice])

    // Brand-config expansion kits (white-label). When the brand declares
    // expansion_kit catalog items they drive the cards (name / hero image /
    // enabled); otherwise the backend-fetched list is used. Config items can
    // also override or hide a backend kit, matched by expansion_kit_key ===
    // backend kit id.
    const configExpansionKits = getExpansionKits()
    const expansionKitOverrides = new Map(
        configExpansionKits.map((k) => [k.expansion_kit_key, k])
    )
    const expansionKitBackendIds = new Set(
        expansionKitItems.map((kit) => kit.id)
    )
    const configOnlyExpansionKits = configExpansionKits
        .filter(
            (k) =>
                k.enabled !== false &&
                !expansionKitBackendIds.has(k.expansion_kit_key)
        )
        .map((k) => {
            const devices = (
                EXPANSION_KITS[k.expansion_kit_key]?.devices || []
            ).map((deviceName) => ({
                id: deviceName.toLowerCase(),
                name: deviceName,
                available: subprogramItems.some(
                    (sub) =>
                        sub.kit === k.expansion_kit_key &&
                        sub.device?.toLowerCase() === deviceName.toLowerCase()
                ),
            }))
            return {
                id: k.expansion_kit_key,
                name: k.display_name,
                imageSrc: k.expansion_kit_key,
                nav:
                    k.nav ||
                    `/expansionKitSelection?expansionKitDevice=${k.expansion_kit_key}`,
                isExpansionKit: true,
                device: devices.length === 1 ? devices[0].name : undefined,
                devices,
                expansionKitKey: k.expansion_kit_key,
            }
        })
    const displayExpansionKits = [
        ...expansionKitItems
            .filter((kit) => {
                const o = expansionKitOverrides.get(kit.id)
                return !o || o.enabled !== false
            })
            .map((kit) => {
                const o = expansionKitOverrides.get(kit.id)
                return {
                    ...kit,
                    name: (o && o.display_name) || kit.name,
                    expansionKitKey: kit.id,
                }
            }),
        // Kits the brand config declares but the backend doesn't know about yet
        // (e.g. brand-new kits added ahead of backend support) — kept visible
        // instead of only showing them when the backend list is empty.
        ...configOnlyExpansionKits,
    ]
    const expansionDevices = displayExpansionKits.reduce((list, kit) => {
        ; (kit.devices || []).forEach((d) => {
            if (d && d.name && !list.includes(d.name)) list.push(d.name)
        })
        return list
    }, [])
    const firstExpansionDevice = expansionDevices[0] || null

    useEffect(() => {
        if (
            expansionKitDeviceMode &&
            firstExpansionDevice &&
            !expansionDevices.includes(selectedExpansionDevice)
        )
            setSelectedExpansionDevice(firstExpansionDevice)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [expansionKitDeviceMode, firstExpansionDevice, selectedExpansionDevice])

    const renderExpansionEmptyState = () => {
        const state =
            expansionKitsStatus === 'loading'
                ? {
                    title: 'Loading kits',
                    subtitle: 'Fetching the latest expansion kits.',
                }
                : expansionKitsStatus === 'error'
                    ? {
                        title: 'Could not load kits',
                        subtitle: 'Check your connection and try again.',
                    }
                    : {
                        title: 'Coming Soon',
                        subtitle: 'New kits are on their way.',
                    }
        return (
            <div className={KitSelectStyle.comingSoon}>
                <p className={KitSelectStyle.comingSoonTitle}>{state.title}</p>
                <p className={KitSelectStyle.comingSoonSubtitle}>
                    {state.subtitle}
                </p>
                {expansionKitsStatus === 'error' && (
                    <button
                        type="button"
                        className={KitSelectStyle.comingSoonAction}
                        onClick={loadExpansionKits}
                    >
                        Retry
                    </button>
                )}
            </div>
        )
    }

    // AI kits show as Computer AI, Vision AI, AI-1 v2, AI-1 v1
    const AI_KIT_ORDER = ['webai', 'wifiCamera', 'Ai0', 'pcAiTool']
    const aiKitRank = (key) => {
        const i = AI_KIT_ORDER.indexOf(key)
        return i === -1 ? AI_KIT_ORDER.length : i
    }

    const tabs = getCategories()
        .map((cat, index) => ({
            id: index + 1,
            slug: cat.slug,
            title: cat.display_name,
            source: cat.source,
            comingSoon: cat.available === false,
            content: getCategoryItems(cat.slug)
                .filter(
                    (it) =>
                        it.type !== 'device' || isDeviceEnabled(it.device_key)
                )
                .map((it) =>
                    it.type === 'accessory' || it.type === 'web_ai'
                        ? {
                            type: it.type,
                            device: it.accessory_key,
                            accessory_key: it.accessory_key,
                            slug: it.slug,
                            name: it.display_name,
                            src: it.src,
                            supported_devices: it.supported_devices || [],
                            comingSoon: it.available === false,
                            discontinued: it.discontinued === true,
                        }
                        : {
                            type: 'device',
                            device: it.device_key,
                            slug: it.slug,
                            name:
                                it.display_name ||
                                getDeviceDisplayName(it.device_key),
                            src: it.src,
                            nav: it.nav || '',
                            peeCeeVariant: it.peecee_variant || '',
                            comingSoon: it.available === false,
                            discontinued: it.discontinued === true,
                        }
                )
                .sort(
                    (a, b) =>
                        a.discontinued - b.discontinued ||
                        aiKitRank(a.device) - aiKitRank(b.device)
                ),
        }))
        .filter((tab) => {
            // Backend-backed tabs stay visible when their API cards exist even
            // though the static catalog content is empty.
            if (tab.content.length > 0) return true
            if (getCategorySource(tab)) return true
            if (isComingSoonCategoryTab(tab)) return true
            return false
        })

    const [modelData, setModelData] = useState({
        isShow: false,
        text: '',
        type: '',
    })

    const languageName = props.device.language

    // ADD THESE LINES RIGHT HERE:
    const [completed, setCompleted] = useState([])

    useEffect(() => {
        setCompleted(getCompletedSubprograms())
    }, [])

    // const [slideDirection, setSlideDirection] = useState(
    //     sessionStorage.getItem('slideDirection')
    // )
    // const optionsToSelect = [
    //     {
    //         text: 'YES',
    //         do: async () => {
    //             console.log(activeTab)
    //             if (activeTab == 3) {
    //                 window.location.href = 'https://playtrons.plode.org/'
    //                 return
    //             }
    //             let connectedDevice = tabs[activeTab - 1].defaultDevice
    //             console.log(tabs[activeTab])
    //             sessionStorage.setItem('connectedDevice', connectedDevice)
    //             let { latestVersion } = await fetchVersion(
    //                 // 'https://embedded.plode.org/version-list',
    //                 'https://embedded.plode.org/version-list-v2',
    //                 connectedDevice
    //                 // connectedDevice == 'Ace' ? '1.0' : '2.0'
    //             )

    //             sessionStorage.setItem(
    //                 'deviceVersion',
    //                 latestVersion.slice(0, latestVersion.length - 2)
    //             )
    //             history.push('/Selection')
    //         },
    //     },
    //     { text: 'NO', do: () => setShowDialog(false) },
    // ]

    const history = useHistory()

    // Codable Kits tab cards + the search index over all subprograms.
    useEffect(() => {
        if (USE_NEW_API) {

            ; (async () => {
                try {
                    const devices = await contentApi.getCodableDevices()
                    setCodableKitItems(
                        devices.map((d) => ({
                            id: d.id,
                            name: d.name,
                            imageSrc: PROGRAM_IMAGE_MAP[d.id] || 'toki',
                            nav: PROGRAM_ENGINE_ROUTE[d.id] || '/make',
                            isProgramCard: true,
                            device: d.name,
                        }))
                    )
                    const tuts = await contentApi.getAllTutorialsSummary()
                    // tutorials carry the lowercase device id; map to display name ('Toki')
                    const deviceNameById = new Map(
                        devices.map((d) => [d.id, d.name])
                    )
                    const toDeviceName = (id) =>
                        deviceNameById.get(id) ||
                        EXPANSION_KIT_TAB_GROUPS.find(
                            (g) => g.device.toLowerCase() === id?.toLowerCase()
                        )?.device ||
                        id
                    setSubprogramItems(
                        tuts.map((t) => ({
                            id: t.id,
                            device: toDeviceName(t.device),
                            name: t.title,
                            backendImage: t.image,
                            nav: `/make/${t.id}`,
                            isCodableKit: true,
                            programId: t.device,
                            kit: t.kit,
                        }))
                    )
                } catch (err) {
                    console.error('Failed to load catalog:', err)
                } finally {
                    setProgramsLoaded(true)
                }
            })()
            return
        }

        fetch(`${BACKEND_URL}/api/programs`)
            .then((res) => res.json())
            .then(async (programs) => {
                // Program-level cards shown in the tab
                const cards = programs.map((prog) => ({
                    id: prog.id,
                    name: prog.title,
                    imageSrc: PROGRAM_IMAGE_MAP[prog.id] || 'toki',
                    nav: PROGRAM_ENGINE_ROUTE[prog.id] || '/make',
                    isProgramCard: true,
                    device: prog.title,
                }))
                setCodableKitItems(cards)

                // Subprograms fetched from all programs for search use
                const allSubs = await Promise.all(
                    programs.map((prog) =>
                        fetch(`${BACKEND_URL}/api/program/${prog.id}`)
                            .then((r) => r.json())
                            .then((data) =>
                                (data.subprograms || []).map((sub) => ({
                                    id: sub.id,
                                    device: prog.title,
                                    name: sub.title,
                                    backendImage: sub.image,
                                    nav: `/make/${sub.id}`,
                                    isCodableKit: true,
                                    programId: prog.id,
                                    // Expansion kit this subprogram belongs to (if any)
                                    kit: sub.kit,
                                }))
                            )
                            .catch(() => [])
                    )
                )
                setSubprogramItems(allSubs.flat())
            })
            .catch((err) => {
                console.error('Failed to load programs:', err)
            })
            .finally(() => setProgramsLoaded(true))
    }, [])

    // Fetch Expansion Kits (same card shape as Codable Kits; content wired later)
    const loadExpansionKits = () => {
        setExpansionKitsStatus('loading')
            ; (USE_NEW_API
                ? contentApi.getExpansionKits()
                : fetch(`${BACKEND_URL}/api/expansion-kits`).then((res) => res.json())
            )
                .then((kits) => {
                    setExpansionKitItems(
                        kits.map((kit) => ({
                            id: kit.id,
                            name: kit.title,
                            imageSrc: kit.image,
                            nav: `/expansionKitSelection?expansionKitDevice=${kit.id}`,
                            isExpansionKit: true,
                            device: kit.title,
                            // Kit-level available from API (false → Coming Soon for all devices)
                            available: kit.available,
                            // Per-device available entries — used for device-specific Coming Soon.
                            // The old /api/expansion-kits response has no per-device breakdown,
                            // so fall back to the static EXPANSION_KITS catalog for which devices
                            // support this kit (kit.available still applies to all of them then).
                            devices:
                                kit.devices?.length
                                    ? kit.devices
                                    : (EXPANSION_KITS[kit.id]?.devices || []).map(
                                        (deviceName) => ({
                                            id: deviceName.toLowerCase(),
                                            name: deviceName,
                                            available: kit.available,
                                        })
                                    ),
                        }))
                    )
                    setExpansionKitsStatus('ready')
                })
                .catch((err) => {
                    console.error('Failed to load expansion kits:', err)
                    setExpansionKitsStatus('error')
                })
    }

    useEffect(() => {
        loadExpansionKits()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // Admin keyboard shortcut: Cmd+Shift+Y (Mac) or Ctrl+Shift+Y (Win/Linux)
    useEffect(() => {
        const handleKeyDown = (e) => {
            const isMac = navigator.userAgent.toUpperCase().includes('MAC')
            const isMacShortcut =
                isMac && e.metaKey && e.shiftKey && e.key.toLowerCase() === 'y'
            const isWinShortcut =
                !isMac && e.ctrlKey && e.shiftKey && e.key.toLowerCase() === 'y'
            if (isMacShortcut || isWinShortcut) {
                e.preventDefault()
                history.push('/admin')
            }
        }
        window.addEventListener('keydown', handleKeyDown)
        return () => window.removeEventListener('keydown', handleKeyDown)
    }, [history])
    const handleHelpBtn = (e) => {
        if (isHelp == true) {
            setHelp(false)
        } else {
            setHelp(true)
        }
    }
    const gobackUrl = () => {
        // setSlideDirection(true)
        sessionStorage.setItem('slideDirection', true)
        history.push('/')
    }

    const clearSearch = () => {
        setSearch('')
        setSuggestions([])
        setFilteredResults({})
        setOpenDeviceFlyout(null)
    }

    const handleHeaderBack = () => {
        clearSearch()
        if (selectedExpansionKit) {
            setSelectedExpansionKit(null)
            setExpansionKitTutorials([])
            return
        }
        if (expansionKitDeviceMode) {
            handleExpansionSidebarBack()
            return
        }
        gobackUrl()
    }

    const handleAutoConnection = () => {
        // Preserve the selected expansion device (and kit, if the user was
        // already viewing one kit's subprograms) so KitSelection restores the
        // same screen instead of dropping back to the device's kit grid when
        // returning from /deviceSelection.
        if (selectedExpansionDevice) {
            sessionStorage.setItem('expansionKitRestoreDevice', selectedExpansionDevice)
            const kitId = selectedExpansionKit?.id || selectedExpansionKit?.expansionKitId
            if (kitId) {
                sessionStorage.setItem('expansionKitRestoreKitId', kitId)
            }
        }
        props.setSelectionBackRoute('/kitSelection')
        sessionStorage.removeItem('allowedDevice')
        history.push('/deviceSelection')
        sessionStorage.removeItem('webAiMode')
        props.setSelectedKit({ aiKitSelected: '' })
    }
    const handleDefaultConnection = () => { }
    const handleDeviceConnection = async (item) => {
        // Web AI mode flag is scoped to the Web AI kit only; clear it for any
        // other selection so a later non-AI kit resets the flow.
        sessionStorage.removeItem('webAiMode')
        sessionStorage.removeItem('allowedPeeCeeVariant')

        // Expansion kit cards → if device is already chosen (device-first mode),
        // load tutorials inline; otherwise fall back to the old device-picker page.
        if (item.isExpansionKit) {
            if (expansionKitDeviceMode && selectedExpansionDevice) {
                // Coming in from a search result (or its device flyout) leaves
                // filteredResults set, which pins the view on that single
                // search-result card forever — clear it so the kit's actual
                // subprogram list (set below) is what renders.
                if (Object.keys(filteredResults).length > 0) {
                    setSearch('')
                    setFilteredResults({})
                }
                const kitId = item.expansionKitId || item.id
                sessionStorage.setItem('expansionKit', kitId)
                // Store display name so downstream pages (SubprogramDetail, Make)
                // can show the correct kit title without relying on a static ID map.
                sessionStorage.setItem('expansionKitName', item.name || kitId)
                // Tell KitMenu to return here (not to /expansionKitSelection)
                sessionStorage.setItem('expansionKitReturnRoute', '/kitSelection')
                sessionStorage.setItem('connectedDevice', selectedExpansionDevice)
                sessionStorage.setItem('allowedDevice', selectedExpansionDevice)
                try {
                    const versionArgs = getVersionArguments[selectedExpansionDevice]
                    const { latestVersion } = await fetchVersion(
                        versionArgs ? versionArgs.deviceName : 'Playcomputer',
                        versionArgs ? versionArgs.version : '1.0'
                    )
                    sessionStorage.setItem(
                        'deviceVersion',
                        latestVersion.slice(0, latestVersion.length - 2)
                    )
                } catch {
                    sessionStorage.setItem('deviceVersion', '1')
                }
                setSelectedExpansionKit(item)
                setTutorialsLoading(true)
                try {
                    const data = USE_NEW_API
                        ? await contentApi.getKitDeviceSubprograms(
                            kitId,
                            selectedExpansionDevice.toLowerCase()
                        )
                        : await fetch(
                            `${BACKEND_URL}/api/program/${selectedExpansionDevice.toLowerCase()}`
                        ).then((r) => r.json())
                    const visible = (data?.subprograms || []).filter(
                        (sub) => !kitId || sub.kit === kitId
                    )
                    setExpansionKitTutorials(visible)
                } catch {
                    setExpansionKitTutorials([])
                } finally {
                    setTutorialsLoading(false)
                }
                return
            }
            sessionStorage.setItem(
                'expansionKit',
                item.expansionKitId || item.id
            )
            sessionStorage.setItem('expansionKitName', item.name || item.expansionKitId || item.id)
            sessionStorage.removeItem('expansionKitReturnRoute')
            history.push(item.nav)
            return
        }

        // Any non-expansion selection clears the kit filter used by /make
        sessionStorage.removeItem('expansionKit')
        sessionStorage.removeItem('expansionKitName')

        // Handle program-level cards (toki, poki engine redirects)
        if (item.isProgramCard) {
            sessionStorage.setItem('connectedDevice', item.device)
            sessionStorage.setItem('allowedDevice', item.device)

            // Fetch the latest version for the device
            try {
                let { latestVersion } = await fetchVersion(
                    getVersionArguments[item.device]
                        ? getVersionArguments[item.device].deviceName
                        : 'Playcomputer',
                    getVersionArguments[item.device]
                        ? getVersionArguments[item.device].version
                        : '1.0'
                )
                sessionStorage.setItem(
                    'deviceVersion',
                    latestVersion.slice(0, latestVersion.length - 2)
                )
            } catch (error) {
                console.error('Failed to fetch version:', error)
                // Fallback to default version if fetch fails
                sessionStorage.setItem('deviceVersion', '1')
            }

            history.push(item.nav)
            return
        }

        // Handle codable kit subprograms (from search results)
        if (item.isCodableKit) {
            sessionStorage.setItem('connectedDevice', item.device)
            sessionStorage.setItem('allowedDevice', item.device)
            if (item.kit) {
                sessionStorage.setItem('expansionKit', item.kit)
            } else {
                sessionStorage.removeItem('expansionKit')
            }

            // Fetch the latest version for the device
            try {
                let { latestVersion } = await fetchVersion(
                    getVersionArguments[item.device]
                        ? getVersionArguments[item.device].deviceName
                        : 'Playcomputer',
                    getVersionArguments[item.device]
                        ? getVersionArguments[item.device].version
                        : '1.0'
                )
                sessionStorage.setItem(
                    'deviceVersion',
                    latestVersion.slice(0, latestVersion.length - 2)
                )
            } catch (error) {
                console.error('Failed to fetch version:', error)
                sessionStorage.setItem('deviceVersion', '1')
            }

            history.push(item.nav)
            return
        }

        if (
            ['Dynamex', 'Dynamex-2', 'Mex', 'Playtrons', 'Playtronix'].includes(
                item.name
            )
        ) {
            window.open(item.nav, '_self')
            return
        }

        if (
            item.type === 'accessory' ||
            item.type === 'web_ai' ||
            ['pcAiTool', 'Ai0'].includes(item.device)
        ) {
            if (item.type === 'web_ai') {
                sessionStorage.setItem('webAiMode', 'true')
            }
            props.setSelectedKit({ ...item, aiKitSelected: item.device })
            history.push({
                pathname: '/aiKitSelection',
                search: `?aiDevice=${item.device}`,
            })
            return
        } else {
            props.setSelectedKit({ ...item, aiKitSelected: '' })
            sessionStorage.setItem('allowedDevice', item.device)
            if (item.peeCeeVariant) {
                sessionStorage.setItem(
                    'allowedPeeCeeVariant',
                    item.peeCeeVariant
                )
            }
            props.setSelectionBackRoute('/kitSelection')
            history.push('/deviceSelection')
        }

        if (item.device === 'Toki' && item.nav) {
            sessionStorage.setItem('connectedDevice', 'Toki')
            sessionStorage.setItem('allowedDevice', 'Toki')

            // Fetch the latest version for Toki
            try {
                let { latestVersion } = await fetchVersion(
                    getVersionArguments['Toki'].deviceName,
                    getVersionArguments['Toki'].version
                )
                sessionStorage.setItem(
                    'deviceVersion',
                    latestVersion.slice(0, latestVersion.length - 2)
                )
            } catch (error) {
                console.error('Failed to fetch Toki version:', error)
                sessionStorage.setItem('deviceVersion', '1')
            }

            history.push(item.nav)
            return
        }

        sessionStorage.setItem('allowedDevice', item.device)
        props.setSelectionBackRoute('/kitSelection')
        history.push('/deviceSelection')
    }

    const openSubprogram = (subId) => {

        if (selectedExpansionDevice && selectedExpansionKit) {
            const kitId = selectedExpansionKit.id || selectedExpansionKit.expansionKitId
            sessionStorage.setItem('expansionKitRestoreDevice', selectedExpansionDevice)
            sessionStorage.setItem('expansionKitRestoreKitId', kitId)
        }

        sessionStorage.setItem('expansionKitReturnRoute', '/kitSelection')
        // Persist the subprogramId so KitMenu can recover it even if the URL
        // loses its query param after navigating through the Code flow.
        sessionStorage.setItem('kitMenuSubprogramId', subId)
        const tutorial = expansionKitTutorials.find((t) => t.id === subId)
        if (tutorial?.title) {
            sessionStorage.setItem('currentTutorialTitle', tutorial.title)
        } else {
            sessionStorage.removeItem('currentTutorialTitle')
        }
        history.push(`/kitMenu?subprogramId=${subId}`)
    }


    useEffect(() => {
        const restoreDevice = sessionStorage.getItem('expansionKitRestoreDevice')
        const restoreKitId = sessionStorage.getItem('expansionKitRestoreKitId')
        if (!restoreDevice) return

        sessionStorage.removeItem('expansionKitRestoreDevice')
        sessionStorage.removeItem('expansionKitRestoreKitId')

        // Device-only restore (e.g. returning from AUTO connection flow):
        // selectedExpansionDevice + expansionKitDeviceMode already set from
        // useState initializer — nothing else to do.
        if (!restoreKitId) return


        const kitItem = {
            id: restoreKitId,
            expansionKitId: restoreKitId,
            name: sessionStorage.getItem('expansionKitName') || restoreKitId,
            isExpansionKit: true,
        }

        // device + mode already initialized from sessionStorage in useState
        setSelectedExpansionKit(kitItem)
        setTutorialsLoading(true)
            ; (async () => {
                try {
                    const data = USE_NEW_API
                        ? await contentApi.getKitDeviceSubprograms(restoreKitId, restoreDevice.toLowerCase())
                        : await fetch(`${BACKEND_URL}/api/program/${restoreDevice.toLowerCase()}`).then((r) => r.json())
                    const visible = (data?.subprograms || []).filter(
                        (sub) => !restoreKitId || sub.kit === restoreKitId
                    )
                    setExpansionKitTutorials(visible)
                } catch {
                    setExpansionKitTutorials([])
                } finally {
                    setTutorialsLoading(false)
                }
            })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        console.log('search', filteredResults)
        // if (search.length == 0) {
        //     // setActiveTab(1)
        //     setFilteredResults({})
        // } else
        if (Object.keys(filteredResults).length > 0) {
            props.setActiveTab(filteredResults.id)
        }
    }, [search])


    useEffect(() => {
        const activeTabId = props.device?.kitSelection?.activeTab
        if (!activeTabId) return
        const currentTab = tabs.find((t) => t.id === activeTabId)
        if (currentTab && isExpansionTab(currentTab) && !expansionKitDeviceMode) {
            setExpansionKitDeviceMode(true)
            setSelectedExpansionDevice(
                (prev) => prev || firstExpansionDevice || null
            )
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.device?.kitSelection?.activeTab])

    // console.log(activeTab)
    const handleSearch = (e) => {
        const value = e.target.value

        setSearch(e.target.value)
        if (!e.target.value.trim()) {
            props.setActiveTab(1)
            setFilteredResults({})
        }
        if (value) {
            const expansionTab = tabs.find(isExpansionTab)

            const allSuggestions = [
                // Codable Kits and Expansion Kits are backend-backed (see
                // isCodableTab/isExpansionTab above) — their real cards come
                // from codableKitItems/displayExpansionKits below, not
                // tab.content, so searching tab.content for them would surface
                // stale catalog entries the tab itself never renders.
                ...[...tabs]
                    .filter(
                        (tab) => !isCodableTab(tab) && !isExpansionTab(tab)
                    )
                    .flatMap((tab) =>
                        tab.content.map((item) => ({
                            name: item.name,
                            src: item.src,
                            nav: item.nav,
                            title: tab.title,
                            id: tab.id,
                            device: item.device,
                            discontinued: item.discontinued,
                            comingSoon: item.comingSoon,
                        }))
                    ),

                // same subprogram name on several devices -> one row with a device flyout
                ...Array.from(
                    subprogramItems
                        .filter((item) => item.kit)
                        .reduce((groups, item) => {
                            const groupKey = `${item.kit || ''}::${item.name}`
                            if (!groups.has(groupKey)) groups.set(groupKey, [])
                            groups.get(groupKey).push(item)
                            return groups
                        }, new Map())
                        .values()
                ).map((group) => {
                    const [first] = group
                    const devices = group.map((g) => ({
                        id: (g.device || '').toLowerCase(),
                        name: g.device,
                        nav: g.nav,
                        subprogramId: g.id,
                        backendImage: g.backendImage,
                        available: !isTutorialComingSoon(g.kit, g.device),
                    }))
                    return {
                        name: first.name,
                        src: first.backendImage,
                        nav: first.nav,
                        title: expansionTab?.title || 'Expansion Kits',
                        id: expansionTab?.id,
                        subprogramId: first.id,
                        flyoutKey: `${first.kit || ''}::${first.name}`,
                        device: devices.length === 1 ? devices[0].name : undefined,
                        devices: devices.length > 1 ? devices : undefined,
                        isCodableKit: true,
                        backendImage: first.backendImage,
                        kit: first.kit,
                    }
                }),
                // Search over expansion kits — the same kit (e.g. "IO Expansion
                // kit 1") can be supported by several devices, so a kit with
                // more than one supporting device gets a `devices` list attached
                // and renders with a flyout arrow (picking a device from the
                // flyout jumps straight into that device's subprograms).
                ...displayExpansionKits.map((item) => ({
                    name: item.name,
                    src: item.imageSrc,
                    imageSrc: item.imageSrc,
                    expansionKitKey: item.expansionKitKey || item.id,
                    nav: item.nav,
                    title: expansionTab?.title || 'Expansion Kits',
                    id: expansionTab?.id,
                    expansionKitId: item.id,
                    flyoutKey: item.id,
                    device: item.devices?.length === 1 ? item.devices[0].name : item.device,
                    devices: item.devices?.length > 1 ? item.devices : undefined,
                    isExpansionKit: true,
                })),
            ]
            const filteredSuggestions = allSuggestions.filter((suggestion) =>
                suggestion.name.toLowerCase().startsWith(value.toLowerCase())
            )
            console.log(filteredSuggestions)
            setSuggestions(filteredSuggestions)
        } else {
            setSuggestions([])
        }
    }
    const handleSuggestion = (suggestion, event) => {
        // Kit supported by several devices — open the side flyout to let the
        // user pick which device instead of selecting the kit right away.
        if (suggestion.devices?.length) {
            const isClosing = openDeviceFlyout === suggestion.flyoutKey
            // Measure synchronously, before any state update is scheduled —
            // by the time a setState updater callback runs, the synthetic
            // event's currentTarget may already have been cleared.
            if (!isClosing && event?.currentTarget && searchInputRef.current) {
                const rowRect = event.currentTarget.getBoundingClientRect()
                const containerRect = searchInputRef.current.getBoundingClientRect()
                setFlyoutTop(rowRect.top - containerRect.top)
            }
            setOpenDeviceFlyout(isClosing ? null : suggestion.flyoutKey)
            return
        }

        setSearch(suggestion.name)
        setFilteredResults(
            suggestion.isExpansionKit
                ? {
                    ...suggestion,
                    comingSoon: isExpansionKitComingSoon(
                        displayExpansionKits.find(
                            (kit) => kit.id === suggestion.expansionKitId
                        ),
                        suggestion.device
                    ),
                }
                : suggestion.isCodableKit
                    ? {
                        ...suggestion,
                        comingSoon: isTutorialComingSoon(
                            suggestion.kit,
                            suggestion.device
                        ),
                    }
                    : suggestion
        )
        setSuggestions([])
        setOpenDeviceFlyout(null)

        const belongsToExpansionKits = Boolean(
            suggestion.isExpansionKit || suggestion.kit || suggestion.isCodableKit
        )
        setExpansionKitDeviceMode(belongsToExpansionKits)
        setSelectedExpansionDevice(
            belongsToExpansionKits
                ? suggestion.device || firstExpansionDevice || null
                : null
        )
    }

    // Picking a device from a suggestion's flyout — resolves to that device
    // and proceeds exactly like a single-device suggestion would.
    const handleSuggestionDevice = (suggestion, device) => {
        setSearch(`${suggestion.name} - ${device.name}`)
        setFilteredResults({
            ...suggestion,
            device: device.name,
            devices: undefined,
            nav: device.nav ?? suggestion.nav,
            subprogramId: device.subprogramId ?? suggestion.subprogramId,
            backendImage: device.backendImage ?? suggestion.backendImage,
            src: device.backendImage ?? suggestion.src,
            ...(suggestion.isExpansionKit && {
                comingSoon: isExpansionKitComingSoon(
                    displayExpansionKits.find(
                        (kit) => kit.id === suggestion.expansionKitId
                    ),
                    device.name
                ),
            }),
            ...(suggestion.isCodableKit && {
                comingSoon: isTutorialComingSoon(suggestion.kit, device.name),
            }),
        })
        setSuggestions([])
        setOpenDeviceFlyout(null)
        setExpansionKitDeviceMode(
            Boolean(suggestion.isExpansionKit || suggestion.kit)
        )
        setSelectedExpansionDevice(device.name)
    }

    const languageActionHandel = () => {
        props.setLanguageSelect({ language: languageValue })
        setShowLanguagePopup(false)
    }
    const handelTabsChange = (tab) => {
        if (filteredResults && Object.keys(filteredResults).length > 0) {
            setSearch('')
            setFilteredResults({})
        }

        if (isExpansionTab(tab)) {
            setExpansionKitDeviceMode(true)
            setSelectedExpansionKit(null)
            setExpansionKitTutorials([])

            setSelectedExpansionDevice(
                (prev) => prev || firstExpansionDevice || null
            )
        }

        props.setActiveTab(tab.id)
    }

    const handleExpansionSidebarBack = () => {
        setSelectedExpansionKit(null)
        setExpansionKitTutorials([])
        setExpansionKitDeviceMode(false)
        setSelectedExpansionDevice(null)
        sessionStorage.removeItem('currentTutorialTitle')
        sessionStorage.removeItem('kitMenuSubprogramId')
        if (tabs[0]) props.setActiveTab(tabs[0].id)
    }

    // Expansion kits that have at least one subprogram/project.
    // Kits absent from this set are shown as "COMING SOON" (disabled).
    const expansionKitsWithProjects = new Set(
        subprogramItems.filter((sub) => sub.kit).map((sub) => sub.kit)
    )

    // Groups the Expansion Kits tab by device (Toki/Poki/Moki) — the sidebar
    // device list picks one of these groups to render as a flat grid, reusing
    // the exact same card/click/image handling as the other tabs.
    // Resolves an expansion kit's card image the same way everywhere it's
    // shown (category grid, search suggestions, selected search result):
    // brand-config hero image, then a pinned local asset, then the backend
    // image. Search results used to skip straight to `renderImage(item.src)`
    // with the backend image value, which isn't a local asset key — broken
    // for any kit (RoArm, Walker) without a brand-config hero image.
    const getExpansionKitImageSrc = (item) => {
        const key = item.expansionKitKey || item.id
        return (
            getExpansionKitHeroImage(key) ||
            (FORCE_LOCAL_EXPANSION_KIT_IMAGE.has(key)
                ? renderImage(key)
                : null) ||
            getBackendImage(item.imageSrc || 'PokiRoverKit.png')
        )
    }

    const isExpansionKitComingSoon = (item, deviceName) => {
        const deviceEntry =
            deviceName && item?.devices?.length
                ? item.devices.find(
                    (d) =>
                        d.id === deviceName.toLowerCase() ||
                        d.name?.toLowerCase() === deviceName.toLowerCase()
                )
                : null

        return deviceEntry != null
            ? !deviceEntry.available
            : item?.available !== undefined
                ? !item.available
                : !expansionKitsWithProjects.has(item?.id)
    }

    // A tutorial with no kit link (the backend clears it while its kit is
    // coming soon) or whose kit/device is unavailable is coming soon.
    const isTutorialComingSoon = (kitId, deviceName) => {
        const kit = displayExpansionKits.find((k) => k.id === kitId)
        return kit ? isExpansionKitComingSoon(kit, deviceName) : true
    }

    const renderExpansionKitCard = (item) => {
        // When a device is selected, check device-level available first.
        // Falls back to kit-level available, then to the subprogram-presence check.
        const isEmptyExpansionKit = isExpansionKitComingSoon(
            item,
            selectedExpansionDevice
        )

        return (
            <div
                key={item.id}
                onClick={() =>
                    isEmptyExpansionKit
                        ? undefined
                        : handleDeviceConnection(item)
                }
                className={KitSelectStyle.card}
                style={
                    isEmptyExpansionKit ? { cursor: 'not-allowed' } : undefined
                }
            >
                <div
                    className={KitSelectStyle.cardImg}
                    style={{ position: 'relative' }}
                >
                    <img
                        src={getExpansionKitImageSrc(item)}
                        alt={item.name}
                        style={{
                            width: '100%',
                            objectFit: 'contain',
                            filter: isEmptyExpansionKit
                                ? 'grayscale(0%)'
                                : undefined,
                            opacity: isEmptyExpansionKit ? 0.7 : 1,
                        }}
                        onError={(e) => {
                            if (e.target.dataset.fallbackApplied) return
                            e.target.dataset.fallbackApplied = 'true'
                            e.target.src =
                                renderImage(item.id) ||
                                renderImage('projectDefault')
                        }}
                    />
                    {isEmptyExpansionKit && (
                        <div className={KitSelectStyle.comingSoonOverlay}>
                            <div className={KitSelectStyle.comingSoonBanner}>
                                {COMING_SOON_TEXT}
                            </div>
                        </div>
                    )}
                </div>
                <div className={KitSelectStyle.cardText}>
                    <p className={KitSelectStyle.cardName}>{item.name}</p>
                </div>
            </div>
        )
    }

    return (
        <>
            <DialogModal
                show={showLanguagePopup}
                text={
                    <div>
                        <p>Select Your Prefer language</p>
                        <div>
                            <select
                                className={KitSelectStyle.language_select}
                                value={languageValue}
                                onChange={(e) =>
                                    setLanguageValue(e.target.value)
                                }
                            >
                                {languageMenu.map((ele) => {
                                    return (
                                        <option key={ele} value={ele}>
                                            {ele}
                                        </option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>
                }
                showCloseBtn={true}
                handleDialogModalClose={() => setShowLanguagePopup(false)}
                optionsToSelect={[
                    {
                        text: 'CONTINUE',
                        do: () => {
                            languageActionHandel()
                        },
                    },
                ]}
            />

            <div className={KitSelectStyle.container}>
                <div className={KitSelectStyle.Connect_Header}>
                    {isHelp ? (
                        <div>
                            <img
                                className={KitSelectStyle.back_btn}
                                style={{ zIndex: '-1' }}
                                src={renderImage('backBtn')}
                                onClick={handleHeaderBack}
                            ></img>{' '}
                        </div>
                    ) : (
                        <div className="">
                            <img
                                className={KitSelectStyle.back_btn}
                                style={{ zIndex: '1000' }}
                                src={renderImage('backBtn')}
                                onClick={handleHeaderBack}
                            ></img>{' '}
                        </div>
                    )}
                    <p className={KitSelectStyle.text}>
                        {languageWords[languageName]?.SelectDevice ||
                            'Select your Kit'}
                    </p>
                    <div>
                        {isHelp == false && (
                            <div>
                                <div className="header_button">
                                    <img
                                        className={KitSelectStyle.helpBtn}
                                        src={renderImage(
                                            'languageIcon'
                                        )}
                                        onClick={() =>
                                            setShowLanguagePopup(true)
                                        }
                                    // style={{ right: '30%' }}
                                    ></img>
                                    <span
                                        className="tooltiptext"
                                        style={{
                                            // top: '13vh',
                                            zIndex: '1',
                                        }}
                                    >
                                        {' '}
                                        <p>Language</p>
                                    </span>
                                </div>
                                <div
                                    className={KitSelectStyle.searchInput}
                                    ref={searchInputRef}
                                >
                                    <input
                                        type="text"
                                        name="search"
                                        placeholder="Search Kits"
                                        value={search}
                                        onChange={handleSearch}
                                    />
                                    {Object.keys(filteredResults).length > 0 ? (
                                        <div
                                            className={KitSelectStyle.binIcon}
                                            onClick={() => {
                                                setSearch('')
                                                props.setActiveTab(1)
                                                setFilteredResults({})
                                            }}
                                        >
                                            <img
                                                src="https://cdn-icons-png.flaticon.com/128/2976/2976286.png"
                                                alt="bin"
                                            />
                                            {/* <img
                                                    src="https://cdn-icons-png.flaticon.com/128/3395/3395538.png"
                                                    alt="search"
                                                /> */}
                                            {/* </div> */}
                                        </div>
                                    ) : (
                                        <div
                                            className={
                                                KitSelectStyle.searchIcon
                                            }
                                        >
                                            <img
                                                src={renderImage('searchIcon')}
                                                alt="search"
                                            />
                                        </div>
                                    )}
                                    {suggestions.length > 0 && (
                                        <ul
                                            className={
                                                KitSelectStyle.suggestions
                                            }
                                        >
                                            {suggestions.map(
                                                (suggestion, index) => (
                                                    <li
                                                        key={index}
                                                        onClick={(e) =>
                                                            handleSuggestion(
                                                                suggestion,
                                                                e
                                                            )
                                                        }
                                                    >
                                                        <img
                                                            width={'24px'}
                                                            src={
                                                                suggestion.isCodableKit
                                                                    ? getBackendImage(
                                                                        suggestion.backendImage ||
                                                                        'projectDefault'
                                                                    )
                                                                    : suggestion.isExpansionKit
                                                                        ? getExpansionKitImageSrc(
                                                                            suggestion
                                                                        )
                                                                        : renderImage(
                                                                            suggestion.src
                                                                        )
                                                            }
                                                            alt={
                                                                suggestion.title
                                                            }
                                                        />
                                                        {/* <span
                                                            className={
                                                                KitSelectStyle.suggestion_title
                                                            }
                                                        >
                                                            {suggestion.title}
                                                        </span>{' '}
                                                        / */}
                                                        <span
                                                            className={
                                                                KitSelectStyle.suggestion_name
                                                            }
                                                        >
                                                            {suggestion.name}
                                                        </span>
                                                        {suggestion.devices?.length > 0 && (
                                                            <span
                                                                style={{
                                                                    marginLeft: 'auto',
                                                                    paddingLeft: '8px',
                                                                    color: '#888',
                                                                }}
                                                            >
                                                                &gt;
                                                            </span>
                                                        )}
                                                    </li>
                                                )
                                            )}
                                        </ul>
                                    )}
                                    {(() => {
                                        const flyoutSuggestion =
                                            suggestions.find(
                                                (s) =>
                                                    s.devices?.length > 0 &&
                                                    s.flyoutKey ===
                                                    openDeviceFlyout
                                            )
                                        if (!flyoutSuggestion) return null
                                        return (
                                            <ul
                                                className={
                                                    KitSelectStyle.suggestions
                                                }
                                                style={{
                                                    top: `${flyoutTop}px`,
                                                    left: 'calc(100% + 8px)',
                                                    width: 'auto',
                                                    minWidth: '8rem',
                                                    margin: 0,
                                                }}
                                            >
                                                {flyoutSuggestion.devices.map(
                                                    (device) => (
                                                        <li
                                                            key={device.id}
                                                            onClick={() =>
                                                                handleSuggestionDevice(
                                                                    flyoutSuggestion,
                                                                    device
                                                                )
                                                            }
                                                        >
                                                            <span
                                                                className={
                                                                    KitSelectStyle.suggestion_name
                                                                }
                                                                style={{
                                                                    marginLeft: 0,
                                                                }}
                                                            >
                                                                {device.name}
                                                            </span>
                                                            {(flyoutSuggestion.isExpansionKit ||
                                                                flyoutSuggestion.isCodableKit) &&
                                                                device.available === false && (
                                                                    <span
                                                                        style={{
                                                                            marginLeft: '8px',
                                                                            color: '#888',
                                                                            fontSize: '0.75em',
                                                                        }}
                                                                    >
                                                                        {COMING_SOON_TEXT}
                                                                    </span>
                                                                )}
                                                        </li>
                                                    )
                                                )}
                                            </ul>
                                        )
                                    })()}
                                </div>
                                {/* <div className="header_button">
                                    <img
                                        className={KitSelectStyle.helpBtn}
                                        src={renderImage('helpBtnInActive')}
                                        onClick={handleHelpBtn}
                                    ></img>
                                    <span className="tooltiptext">
                                        {' '}
                                        <p>Help</p>
                                    </span>
                                </div> */}
                            </div>
                        )}
                    </div>
                </div>

                <div className={KitSelectStyle.Connect_Body}>
                    <div className={KitSelectStyle.tabsParent}>
                        {expansionKitDeviceMode ? (
                            <>
                                <p className={KitSelectStyle.header}>
                                    {languageWords[languageName]?.[
                                        'Expansion Kits'
                                    ] || 'Expansion Kits'}
                                </p>

                                <div className={KitSelectStyle.tabs}>
                                    {expansionDevices.map((device) => (
                                        <div
                                            key={device}
                                            className={`${KitSelectStyle.tab} ${device === selectedExpansionDevice
                                                ? KitSelectStyle.active
                                                : ''
                                                }`}
                                            onClick={() => {
                                                setSelectedExpansionDevice(device)
                                                setSelectedExpansionKit(null)
                                                setExpansionKitTutorials([])
                                                // Switching device from the sidebar leaves search
                                                // mode — clear it so the search box and the
                                                // single search-result card don't stick around.
                                                if (
                                                    filteredResults &&
                                                    Object.keys(filteredResults).length > 0
                                                ) {
                                                    setSearch('')
                                                    setFilteredResults({})
                                                }
                                            }}
                                        >
                                            <p
                                                className={
                                                    KitSelectStyle.title
                                                }
                                            >
                                                {device}
                                            </p>
                                            {device ===
                                                selectedExpansionDevice && (
                                                    <div
                                                        className={
                                                            KitSelectStyle.arrow
                                                        }
                                                    >
                                                        <img
                                                            src={renderImage(
                                                                'arrowRight'
                                                            )}
                                                            alt="arrowRight"
                                                        />
                                                    </div>
                                                )}
                                        </div>
                                    ))}
                                </div>
                            </>
                        ) : (
                            <>
                                <p className={KitSelectStyle.header}>
                                    {languageWords[languageName]?.Device ||
                                        'Kits'}
                                </p>

                                <div className={KitSelectStyle.tabs}>
                                    {tabs.map((tab) => (
                                        <div
                                            key={tab.id}
                                            className={`${KitSelectStyle.tab} ${tab.id === (props.device?.kitSelection?.activeTab || 1)
                                                ? KitSelectStyle.active
                                                : ''
                                                }`}
                                            onClick={() =>
                                                handelTabsChange(tab)
                                            }
                                        >
                                            <p
                                                className={
                                                    KitSelectStyle.title
                                                }
                                            >
                                                {languageWords[
                                                    languageName
                                                ]?.[tab.title] || tab.title}
                                            </p>
                                            {tab.id ===
                                                (props.device?.kitSelection
                                                    ?.activeTab || 1) && (
                                                    <div
                                                        className={
                                                            KitSelectStyle.arrow
                                                        }
                                                    >
                                                        <img
                                                            src={renderImage(
                                                                'arrowRight'
                                                            )}
                                                            alt="arrowRight"
                                                        />
                                                    </div>
                                                )}
                                        </div>
                                    ))}
                                </div>
                            </>
                        )}
                    </div>
                    <div className={KitSelectStyle.content}>
                        {expansionKitDeviceMode &&
                            (!filteredResults?.id ||
                                (filteredResults.isCodableKit &&
                                    filteredResults.kit)) && (
                                <p style={{ color: '#717171', borderBottom: '1px solid rgb(218,214,214)', marginBottom: '0.5rem' }}>
                                    {filteredResults?.isCodableKit && filteredResults.kit
                                        ? `${displayExpansionKits.find(
                                            (kit) => kit.id === filteredResults.kit
                                        )?.name || filteredResults.kit
                                        } · ${selectedExpansionDevice}`
                                        : selectedExpansionKit
                                            ? `${selectedExpansionKit.name} · ${selectedExpansionDevice}`
                                            : selectedExpansionDevice
                                                ? 'Select an expansion kit'
                                                : 'Select a device'}
                                </p>
                            )}
                        {filteredResults &&
                            Object.keys(filteredResults).length > 0 ? (
                            <div className={KitSelectStyle.tabContent}>
                                {/* search result card */}
                                {(() => {
                                    // Check if the filtered result is a completed codable kit
                                    const isCompleted =
                                        filteredResults.isCodableKit &&
                                        completed.includes(
                                            filteredResults.subprogramId
                                        )

                                    return (
                                        <div
                                            onClick={() =>
                                                filteredResults.comingSoon
                                                    ? undefined
                                                    : handleDeviceConnection(
                                                        filteredResults
                                                    )
                                            }
                                            className={`${KitSelectStyle.card} ${isCompleted ? KitSelectStyle.cardCompleted : ''}`}
                                            style={
                                                filteredResults.comingSoon
                                                    ? { cursor: 'not-allowed' }
                                                    : undefined
                                            }
                                        >
                                            <div
                                                className={
                                                    KitSelectStyle.cardImg
                                                }
                                                style={{ position: 'relative' }}
                                            >
                                                <img
                                                    src={
                                                        filteredResults.isCodableKit
                                                            ? getBackendImage(
                                                                filteredResults.backendImage ||
                                                                'projectDefault'
                                                            )
                                                            : filteredResults.isExpansionKit
                                                                ? getExpansionKitImageSrc(
                                                                    filteredResults
                                                                )
                                                                : renderImage(
                                                                    filteredResults.src
                                                                )
                                                    }
                                                    alt={filteredResults.name}
                                                    className={
                                                        isCompleted
                                                            ? KitSelectStyle.imageCompleted
                                                            : ''
                                                    }
                                                    style={
                                                        filteredResults.discontinued
                                                            ? {
                                                                filter: 'grayscale(100%)',
                                                                opacity: 0.7,
                                                            }
                                                            : undefined
                                                    }
                                                />
                                                {filteredResults.comingSoon && (
                                                    <div
                                                        className={
                                                            KitSelectStyle.comingSoonOverlay
                                                        }
                                                    >
                                                        <div
                                                            className={
                                                                KitSelectStyle.comingSoonBanner
                                                            }
                                                        >
                                                            {COMING_SOON_TEXT}
                                                        </div>
                                                    </div>
                                                )}
                                                {filteredResults.discontinued && (
                                                    <div
                                                        className={
                                                            KitSelectStyle.discontinuedOverlay
                                                        }
                                                    >
                                                        <div
                                                            className={
                                                                KitSelectStyle.discontinuedBanner
                                                            }
                                                        >
                                                            {DISCONTINUED_TEXT}
                                                        </div>
                                                    </div>
                                                )}
                                                {/* Add Badge to search results too */}
                                                {isCompleted && (
                                                    <div
                                                        className={
                                                            KitSelectStyle.completedBadge
                                                        }
                                                    >
                                                        <svg
                                                            viewBox="0 0 24 24"
                                                            width="22"
                                                            height="22"
                                                        >
                                                            <circle
                                                                cx="12"
                                                                cy="12"
                                                                r="12"
                                                                fill="#4caf50"
                                                            />
                                                            <path
                                                                d="M7 12l3 3 7-7"
                                                                fill="none"
                                                                stroke="white"
                                                                strokeWidth="2.5"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                        </svg>
                                                    </div>
                                                )}
                                            </div>
                                            <p
                                                className={`${KitSelectStyle.cardName} ${isCompleted ? KitSelectStyle.textCompleted : ''}`}
                                            >
                                                {filteredResults.name}
                                            </p>
                                        </div>
                                    )
                                })()}
                            </div>
                        ) : expansionKitDeviceMode ? (
                            /* ── Expansion kit device-first view ──────────────── */
                            <div
                                ref={expansionTabContentRef}
                                className={KitSelectStyle.tabContent}
                            >
                                {selectedExpansionKit ? (
                                    tutorialsLoading ? null : expansionKitTutorials.length === 0 ? (
                                        <div className={KitSelectStyle.comingSoon}>
                                            <p className={KitSelectStyle.comingSoonTitle}>No tutorials yet</p>
                                            <p className={KitSelectStyle.comingSoonSubtitle}>
                                                No projects available for this combination.
                                            </p>
                                        </div>
                                    ) : (
                                        expansionKitTutorials.map((sub) => (
                                            <div
                                                key={sub.id}
                                                onClick={() => openSubprogram(sub.id)}
                                                className={KitSelectStyle.card}
                                            >
                                                <div className={KitSelectStyle.cardImg}>
                                                    <img
                                                        src={getBackendImage(sub.image || 'projectDefault')}
                                                        alt={sub.title}
                                                        style={{ width: '100%', objectFit: 'contain' }}
                                                        onError={(e) => {
                                                            if (e.target.dataset.fallbackApplied) return
                                                            e.target.dataset.fallbackApplied = 'true'
                                                            e.target.src = renderImage('projectDefault')
                                                        }}
                                                    />
                                                </div>
                                                <p className={KitSelectStyle.cardName}>{sub.title}</p>
                                            </div>
                                        ))
                                    )
                                ) : (() => {
                                    const deviceKits = displayExpansionKits.filter((kit) => {
                                        if (kit.devices?.length) {
                                            return kit.devices.some(
                                                (d) =>
                                                    d.id === selectedExpansionDevice?.toLowerCase() ||
                                                    d.name?.toLowerCase() === selectedExpansionDevice?.toLowerCase()
                                            )
                                        }
                                        return EXPANSION_KITS[kit.id]?.devices?.includes(selectedExpansionDevice)
                                    })
                                    return deviceKits.length > 0
                                        ? deviceKits.map(renderExpansionKitCard)
                                        : renderExpansionEmptyState()
                                })()}
                            </div>
                        ) : (
                            <>
                                {tabs.map(
                                    (tab, index) =>
                                        tab.id === (props.device?.kitSelection?.activeTab || 1) && (
                                            <div
                                                key={index}
                                                className={KitSelectStyle.tabContent}
                                            >
                                                {isCodableTab(tab) ? (
                                                    programsLoaded && codableKitItems.length === 0 ? (
                                                        <div className={KitSelectStyle.comingSoon}>
                                                            <p className={KitSelectStyle.comingSoonTitle}>
                                                                Coming Soon
                                                            </p>
                                                            <p className={KitSelectStyle.comingSoonSubtitle}>
                                                                New kits are on their way.
                                                            </p>
                                                        </div>
                                                    ) : (
                                                        codableKitItems.map((item) => {
                                                            return (
                                                                <div
                                                                    key={item.id}
                                                                    onClick={() =>
                                                                        handleDeviceConnection(
                                                                            item
                                                                        )
                                                                    }
                                                                    className={
                                                                        KitSelectStyle.card
                                                                    }
                                                                >
                                                                    <div
                                                                        className={
                                                                            KitSelectStyle.cardImg
                                                                        }
                                                                        style={{
                                                                            position:
                                                                                'relative',
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src={
                                                                                getCardHeroImage(item) ||
                                                                                renderImage(
                                                                                    item.imageSrc
                                                                                )
                                                                            }
                                                                            alt={
                                                                                item.name
                                                                            }
                                                                            style={{
                                                                                width: '100%',
                                                                                objectFit:
                                                                                    'contain',
                                                                            }}
                                                                            onError={(
                                                                                e
                                                                            ) => {
                                                                                if (
                                                                                    e
                                                                                        .target
                                                                                        .dataset
                                                                                        .fallbackApplied
                                                                                )
                                                                                    return
                                                                                e.target.dataset.fallbackApplied =
                                                                                    'true'
                                                                                e.target.src =
                                                                                    renderImage(
                                                                                        item.id
                                                                                    ) ||
                                                                                    renderImage(
                                                                                        'projectDefault'
                                                                                    )
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <div className={KitSelectStyle.cardText}>
                                                                        <p
                                                                            className={
                                                                                KitSelectStyle.cardName
                                                                            }
                                                                        >
                                                                            {
                                                                                item.name
                                                                            }
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    )
                                                ) : isComingSoonCategoryTab(tab) &&
                                                    tab.content.length === 0 ? (
                                                    <div className={KitSelectStyle.comingSoon}>
                                                        <p className={KitSelectStyle.comingSoonTitle}>
                                                            Coming Soon
                                                        </p>
                                                        <p className={KitSelectStyle.comingSoonSubtitle}>
                                                            New kits are on their way.
                                                        </p>
                                                    </div>
                                                ) : (
                                                    tab.content.map(
                                                        (item, index) => (
                                                            <div
                                                                key={index}
                                                                onClick={() =>
                                                                    item.comingSoon
                                                                        ? undefined
                                                                        : handleDeviceConnection(
                                                                            item
                                                                        )
                                                                }
                                                                className={
                                                                    KitSelectStyle.card
                                                                }
                                                                style={
                                                                    item.comingSoon
                                                                        ? {
                                                                            cursor: 'not-allowed',
                                                                        }
                                                                        : undefined
                                                                }
                                                            >
                                                                <div
                                                                    className={
                                                                        KitSelectStyle.cardImg
                                                                    }
                                                                    style={{
                                                                        position: 'relative',
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={
                                                                            getCardHeroImage(item) ||
                                                                            renderImage(
                                                                                item.src
                                                                            )
                                                                        }
                                                                        alt={
                                                                            item.src
                                                                        }
                                                                        style={
                                                                            item.discontinued
                                                                                ? {
                                                                                    filter: 'grayscale(100%)',
                                                                                    opacity: 0.7,
                                                                                }
                                                                                : undefined
                                                                        }
                                                                    />
                                                                    {item.comingSoon && (
                                                                        <div
                                                                            className={
                                                                                KitSelectStyle.comingSoonOverlay
                                                                            }
                                                                        >
                                                                            <div
                                                                                className={
                                                                                    KitSelectStyle.comingSoonBanner
                                                                                }
                                                                            >
                                                                                {
                                                                                    COMING_SOON_TEXT
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                    {item.discontinued && (
                                                                        <div
                                                                            className={
                                                                                KitSelectStyle.discontinuedOverlay
                                                                            }
                                                                        >
                                                                            <div
                                                                                className={
                                                                                    KitSelectStyle.discontinuedBanner
                                                                                }
                                                                            >
                                                                                {
                                                                                    DISCONTINUED_TEXT
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>

                                                                <div className={KitSelectStyle.cardText}>
                                                                    <p
                                                                        className={
                                                                            KitSelectStyle.cardName
                                                                        }
                                                                        style={
                                                                            codableKits.includes(
                                                                                item.id
                                                                            )
                                                                                ? {
                                                                                    marginBottom:
                                                                                        '0px',
                                                                                }
                                                                                : {}
                                                                        }
                                                                    >
                                                                        {
                                                                            item.name
                                                                        }
                                                                    </p>

                                                                    {codableKits.includes(
                                                                        item.id
                                                                    ) && (
                                                                            <p
                                                                                className={
                                                                                    KitSelectStyle.cardDeviceName
                                                                                }
                                                                            >
                                                                                {getDeviceDisplayName(
                                                                                    item.device
                                                                                )}
                                                                            </p>
                                                                        )}
                                                                </div>
                                                            </div>
                                                        )
                                                    )
                                                )}
                                            </div>
                                        )
                                )}
                            </>
                        )}
                    </div>
                </div>

                <div className={KitSelectStyle.Connect_Footer}>
                    {/* <div
                        className={KitSelectStyle.navigate}
                        onClick={() => setShowDialog(true)}
                    >
                        <img
                            src={renderImage('doubleArrow')}
                            alt="arrowRight"
                        />
                    </div> */}
                    <div
                    // className={KitSelectStyle.auto}
                    >
                        <img
                            style={{ width: '90px', cursor: 'pointer' }}
                            src={renderImage('auto')}
                            alt="arrowRight"
                            onClick={handleAutoConnection}
                        />
                    </div>
                </div>
            </div>

            {isHelp && (
                <div
                    style={{
                        height: '100vh',
                        width: '100vw',
                        background: '#fff',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%,-50%)',
                        zIndex: '1000',
                        position: 'absolute',
                    }}
                >
                    <div
                        style={{
                            transform: 'translate(-50%,-50%)',
                            top: '47%',
                            left: '50%',
                            zIndex: '10',
                            position: 'absolute',
                            width: '65vw',
                        }}
                    >
                        <div className={KitSelectStyle.web_button}>
                            <img
                                className={KitSelectStyle.Cross}
                                src={renderImage('clos')}
                                onClick={handleHelpBtn}
                            ></img>
                        </div>
                        <div>
                            <img
                                src={
                                    sessionStorage.getItem(
                                        'connectedDevice'
                                    ) === 'Humanoid'
                                        ? renderImage('ZingConnect')
                                        : renderImage('Connect')
                                }
                                style={{
                                    width: '100%',
                                }}
                            ></img>
                        </div>
                        <div className={KitSelectStyle.instr}>
                            <p className={KitSelectStyle.instr_P}>
                                {' '}
                                Help Button will explain all the features and
                                functionality of the entire app for each
                                screen{' '}
                            </p>
                        </div>
                        <div className={KitSelectStyle.instr2}>
                            <p className={KitSelectStyle.instr2_P}>
                                Manual scan will list all the Playcomputer
                                devices if multiple devices are ON
                            </p>
                        </div>
                        <div className={KitSelectStyle.instr3}>
                            <p className={KitSelectStyle.instr3_P}>
                                Skip button will skip the scanning and
                                connecting over bluetooth to playcomputer.If you
                                skip you will not be able to send data to
                                playcomputer.{' '}
                            </p>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

const mapStateToProps = (state) => {
    return state
}
const mapDispatchToProps = (dispatch) => {
    return {
        setLanguageSelect: (data) => {
            dispatch(setLanguageSelect(data))
        },
        setSocket: (data) => {
            dispatch({ type: 'SOCKET', payload: data })
        },
        setSelectedKit: (data) => {
            dispatch({ type: 'SET_SELECTED_KIT', payload: data })
        },
        setActiveTab: (data) => {
            dispatch({ type: 'SET_ACTIVE_TAB', payload: data })
        },
        setSelectionBackRoute: (data) => {
            dispatch(setSelectionBackRoute(data))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(KitSelection)
